module.exports = __webpack_public_path__ + "static/media/service-banner.e32143d6.svg";